<template>
  <div>
    <div class="vx-row">
      <vs-card>
        <div slot="header">
          <h5>SLA par catégorie et par période</h5>
        </div>
        <vs-row>
          <vs-col>
            <div class="flex -mx-2">
              <div class="w-1/4 px-2">
                <vs-select
                  v-model="category"
                  placeholder="Selectionner"
                  class="w-full"
                  label="Type de demande"
                  label-placeholder="Selectionner"
                  autocomplete
                >
                  <vs-select-item
                    value=""
                    text="-- Sélectionner une catégorie --"
                  />
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in categories"
                  />
                </vs-select>
              </div>
              <div class="w-2/4 px-2">
                <span class="vs-select--label">Période</span>
                <date-range-picker
                  ref="picker"
                  :opens="opens"
                  :locale-data="locale"
                  :singleDatePicker="false"
                  :timePicker="false"
                  :showWeekNumbers="showWeekNumbers"
                  :showDropdowns="showDropdowns"
                  :autoApply="autoApply"
                  v-model="dateRange"
                  :ranges="false"
                  @update="updateValues"
                  :linkedCalendars="linkedCalendars"
                  :dateFormat="dateFormat"
                  :always-show-calendars="false"
                  :alwaysShowCalendars="alwaysShowCalendars"
                  class="vs-inputx vs-input--input"
                >
                  <div
                    slot="input"
                    slot-scope="picker"
                    style="min-width: 350px"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </div>
                </date-range-picker>
              </div>
              <div class="w-1/8 px-2">
                <vs-button
                  :disabled="
                    dateRange.startDate === '' && dateRange.endDate === ''
                  "
                  @click="makeSearch()"
                  style="margin-top: 18px"
                  color="primary"
                  type="filled"
                  icon="search"
                >
                  Recherche
                </vs-button>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>

    <div class="vx-row">
      <vs-card>
        <vs-row>
          <vs-col>
            <div class="flex -mx-2">
              <div class="w-1/3 px-2">
                <vx-card class="overflow-hidden">
                  <div slot="no-body">
                    <div
                      class="
                        p-6
                        flex
                        justify-between
                        flex-row-reverse
                        items-center
                      "
                    >
                      <small class="flex cursor-pointer"></small>
                      <div class="truncated">
                        <h2 class="mb-1 font-bold">
                          {{ stats.total_sub_types }}
                        </h2>
                        <span>Total sous-types</span>
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>
              <div class="w-1/3 px-2">
                <vx-card class="overflow-hidden">
                  <div slot="no-body">
                    <div
                      class="
                        p-6
                        flex
                        justify-between
                        flex-row-reverse
                        items-center
                      "
                    >
                      <small class="flex cursor-pointer"></small>
                      <div class="truncated">
                        <h2 class="mb-1 font-bold">
                          {{ stats.total_sla_postive }}
                        </h2>
                        <span>Total SLA positif</span>
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>
              <div class="w-1/3 px-2">
                <vx-card
                  class="overflow-hidden"
                  card-background="primary"
                  content-color="#fff"
                >
                  <div slot="no-body">
                    <div
                      class="
                        p-6
                        flex
                        justify-between
                        flex-row-reverse
                        items-center
                      "
                    >
                      <small class="flex cursor-pointer"></small>
                      <div class="truncated">
                        <h2 class="mb-1 font-bold text-white">
                          {{ stats.percent }}
                        </h2>
                        <span>Pourcentage (%)</span>
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col class="pt-4">
            <vs-table :data="infos" class="table-dark-inverted">
              <template slot="thead">
                <vs-th width="30%">Sous-types de demande</vs-th>
                <vs-th>Nombre total de demandes</vs-th>
                <vs-th>Temps moyen de traitement</vs-th>
                <vs-th>SLA Total</vs-th>
                <vs-th>SLA respecté</vs-th>
                <vs-th>Actions</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{ tr.name }}</span>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.total }}</span></vs-td
                  >
                  <vs-td
                    ><span>{{ formatDuration(tr.tmt) }}</span></vs-td
                  >
                  <vs-td
                    ><span>{{ formatDuration(tr.sla_total) }}</span></vs-td
                  >
                  <vs-td>
                    <vs-chip
                      :color="tr.sla_good ? 'success' : 'danger'"
                      class="product-order-status"><span>{{ tr.sla_good ? "OUI" : "NON" }}</span></vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-button
                      :disabled="
                        dateRange.startDate === '' && dateRange.endDate === ''
                      "
                      @click="exportDetails(tr.id)"
                      color="primary"
                      type="border"
                      size="small"
                    >
                      Exporter les détails
                    </vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment, { min } from "moment";
import { _buildQuery } from "../../../helpers/helper";

export default {
  name: "slaCategoryPeriod",
  components: { DateRangePicker },
  data: () => ({
    stats: {},
    infos: [],
    opens: "center",
    showWeekNumbers: true,
    linkedCalendars: true,
    alwaysShowCalendars: true,
    showDropdowns: true,
    autoApply: false,
    locale: {
      direction: "ltr",
      format: "dd/mm/yyyy",
      separator: " - ",
      applyLabel: "Appliquer",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Aou",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      firstDay: 0,
    },
    dateRange: {
      startDate: "",
      endDate: "",
    },
    dateFormat(classes, date) {
      let yesterday = moment().subtract(1, "day");
      if (!classes.disabled) {
      }
      return classes;
    },
    category: "",
    categories: [],
  }),
  mounted() {
    this.dateRange.startDate = moment(new Date()).format("YYYY-MM-DD");
    this.dateRange.endDate = moment(new Date()).format("YYYY-MM-DD");
    this.getCategories();
    this.makeSearch();
  },
  methods: {
    formatDuration(minutes) {
      const secs = minutes * 60;
      const formatted = moment.utc(secs * 1000).format("HH:mm:ss");
      return formatted;
    },
    updateValues(values) {
      this.dateRange.startDate = moment(values.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(values.endDate).format("YYYY-MM-DD");
    },

    getCategories() {
      this.$http
        .get("/categories-requests?paginate=0")
        .then((response) => {
          this.categories = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },

    makeSearch() {
      this.$vs.loading();
      this.$http
        .post("/ebu/sla-category-period?export=0", {
          date_debut: this.dateRange.startDate,
          date_fin: this.dateRange.endDate,
          type: this.category,
        })
        .then((response) => {
          this.stats = response.data.stats;
          this.infos = response.data.infos;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },
    exportDetails(subtype) {
      this.$vs.loading();
      let params = {
        date_debut: this.dateRange.startDate,
        date_fin: this.dateRange.endDate,
        export: "1",
        subtype: subtype,
      };
      this.$http
        .post(
          "/ebu/sla-category-period" + _buildQuery(params),
          {
            date_debut: this.dateRange.startDate,
            date_fin: this.dateRange.endDate,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = link.href = url;
          link.setAttribute("download", "details.xlsx");
          document.body.appendChild(link);
          link.click();
          this.customer = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style>
</style>
